export default "__VITE_ASSET__uUQMNE3E__"